import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import ApiCalls from "../../config/apiCalls";
import Utility from "../../helpers/utility";
import { MINIAPP } from "../../helpers/paymentConstants";
import headers from "../../config/headers";
import loginSuccess from "../../helpers/login";
import { keyMapsMutation } from "../../helpers/storeKeys";

export default {
  namespaced: true,
  state: {
    bridgeData: {},
    isBridgeApiLoaded: false,
    bridgeError: null,
    nxgLoyaltyMenuData: null,
    unfilteredNxgLoyaltyMenuData: null,
    nxgLoyaltyMenuDataArray: [],
    pizzaToppings: null,
    cheesyFaqData: {},
    cheesyPOTPInfoData: {},
    isLoyaltyMenuScrolled: false,
    enrollingCheesyRewards: false,
    cheesyRewardsSuccessPopup: false,
    isOptOutLoyaltyEnabled: false,
    isTncEnabled: false,
    isFaqEnabled: false,
    showHistoryCta: false,
    loyaltyStatement: {},
    walletData: {},
    currentLoyaltyPointsUsed: 0,
    maxPizzaToBeRedeemed: null,
    maxLoyaltyPointsToBeRedeemed: null,
    dataObjFromMobileDevice: {},
    maxPizzaRedeemed: false,
    maxLoyaltyPointsRedeemed: false,
    loyaltyTabFoundation: null,
    loyaltyMenuApiLoaded: false,
    nxgLoyaltyMenuDataClient: null,
    loyaltyProductsData: null,
    appDataReceived: {},
    redeemPointsSlab: [], //null,
    loyaltyMenuType: null,
    isLoyaltyStatementApiSettled: false,
    isWalletCashbackApiSettled: false,
    loyTnc: LocalStorageFunc.getLoyTnc(),
    loyaltyPlatform: "",
    loyaltyProductsDataForceRefresh: false,
    minimumPointsShownToUser: 0,
  },
  getters: {
    getIsBridgeApiLoaded: (state) => state.isBridgeApiLoaded,
    getBridgeError: (state) => state.bridgeError,
    getNxgLoyaltyMenuData: (state) => state.nxgLoyaltyMenuData,
    getPizzaToppings: (state) => state.pizzaToppings,
    getCurrentLoyaltyPoints: (state, getters, rootState) => {
      return (
        rootState?.User?.walletBalance?.loyaltyProgram?.balance?.overall
          ?.points - state.currentLoyaltyPointsUsed
      );
    },
  },
  mutations: {
    updateBridgeData(state, payload) {
      state.bridgeData = payload;
    },
    updateLoyaltyPlatform(state, payload) {
      state.loyaltyPlatform = payload;
    },
    updateLoyTnc(state, payload) {
      LocalStorageFunc.setLoyTnc(payload);
      state.loyTnc = payload;
    },
    updateIsBridgeApiLoaded(state, payload) {
      state.isBridgeApiLoaded = payload;
    },
    updateBridgeError(state, payload) {
      state.bridgeError = payload;
    },
    updateLoyaltyTabFoundation(state, payload) {
      state.loyaltyTabFoundation = payload;
    },
    updateLoyaltyStatementApiSettled(state, payload) {
      state.isLoyaltyStatementApiSettled = payload;
    },
    updateWalletCashbackApiSettled(state, payload) {
      state.isWalletCashbackApiSettled = payload;
    },
    updateNxgLoyaltyMenu(state, payload) {
      const { Items = {} } = payload;
      state.nxgLoyaltyMenuData = payload;
      state.unfilteredNxgLoyaltyMenuData = payload;
      const sortedArray = Utility.sortLoyaltyItems(
        Items?.data,
        "reqPointsToRedeem",
        "itemPrice",
        "asc",
      );
      state.nxgLoyaltyMenuDataArray = sortedArray || [];
    },
    updatePizzaToppings(state, payload) {
      state.pizzaToppings = payload;
    },
    updateLoyaltyMenuScroll(state, payload) {
      state.isLoyaltyMenuScrolled = payload;
    },
    updateEnrollingCheesyRewards(state, payload) {
      state.enrollingCheesyRewards = payload;
    },
    updateCheesyRewardsSuccessPopup(state, payload) {
      state.cheesyRewardsSuccessPopup = payload;
    },
    updateOptOutLoyaltyEnabled(state, payload) {
      state.isOptOutLoyaltyEnabled = payload;
    },
    updateTncEnabled(state, payload) {
      state.isTncEnabled = payload;
    },
    updateFaqEnabled(state, payload) {
      state.isFaqEnabled = payload;
    },
    updateShowHistoryCta(state, payload) {
      state.showHistoryCta = payload;
    },
    updateLoyaltyStatement(state, payload) {
      state.loyaltyStatement = payload;
    },
    updateWalletData(state, payload) {
      state.walletData = payload;
    },
    updateCheesyFaqData(state, payload) {
      if (payload) {
        const { data = [], version = null } = payload;
        if (data.length) {
          const { faq = [] } = data[0];
          state.cheesyFaqData[version] = faq;
        } else {
          state.cheesyFaqData[version] = [];
        }
      } else {
        state.cheesyFaqData[version] = [];
      }
    },
    updateCheesyPOTPInfoData(state, payload) {
      if (payload) {
        const { data = [], version = null } = payload;
        if (data.length) {
          const { info = [] } = data[0];
          state.cheesyPOTPInfoData[version] = info;
        } else {
          state.cheesyPOTPInfoData[version] = [];
        }
      } else {
        state.cheesyPOTPInfoData[version] = [];
      }
    },
    updatecurrentLoyaltyPointsUsed(state, payload = 0) {
      try {
        state.currentLoyaltyPointsUsed += Number(payload);

        if (
          state.maxLoyaltyPointsToBeRedeemed != undefined &&
          state.maxLoyaltyPointsToBeRedeemed != null
        ) {
          if (
            Number(state.currentLoyaltyPointsUsed) >=
            Number(state.maxLoyaltyPointsToBeRedeemed)
          ) {
            state.maxLoyaltyPointsRedeemed = true;
          } else {
            state.maxLoyaltyPointsRedeemed = false;
          }
        }
      } catch (e) {
        console.error("Error updating current loyalty points: ", e);
      }
    },
    updateMaxPizzaToBeRedeemed(state, payload) {
      state.maxPizzaToBeRedeemed = payload;
    },
    updateMaxLoyaltyPointsToBeRedeemed(state, payload) {
      state.maxLoyaltyPointsToBeRedeemed = payload;
    },
    updateDataObjFromMobileDevice(state, payload) {
      state.dataObjFromMobileDevice = payload;
    },
    updateMaxPizzaRedeemed(state, payload) {
      state.maxPizzaRedeemed = payload;
    },
    updateMaxLoyaltyPointsRedeemed(state, payload) {
      state.maxLoyaltyPointsRedeemed = payload;
    },
    filterNxgLoyaltyMenuData(state, payload) {
      const { cartData, filterProductItem = [], resetSort = false } = payload;
      let res = { ...state.unfilteredNxgLoyaltyMenuData };
      const unFilteredData = res?.Items?.data || {};
      filterProductItem?.map((_) => {
        if (_.group == "FILTER") {
          if (_.type == "VEG") {
            for (const [key, value] of Object.entries(res)) {
              res[key] = { ...value };
              res[key].data = { ...value.data };
              for (const [key2, value2] of Object.entries(value.data)) {
                if (
                  value2.productType != 0 &&
                  !Utility.returnsGetItemWQuantity(cartData, value2)
                ) {
                  res[key].data[key2] = { ...value2 };
                  delete res[key].data[key2];
                }
              }
            }
          } else if ((_.type = "NONVEG")) {
            for (const [key, value] of Object.entries(res)) {
              if (key == "Beverages" || key == "Dessert") continue;
              res[key] = { ...value };
              res[key].data = { ...value.data };
              for (const [key2, value2] of Object.entries(value.data)) {
                if (
                  value2.productType != 1 &&
                  !Utility.returnsGetItemWQuantity(cartData, value2)
                ) {
                  res[key].data[key2] = { ...value2 };
                  delete res[key].data[key2];
                }
              }
            }
          }
        } else if (_.group == "SORT") {
          if (_.type == "HIGH_TO_LOW") {
            for (const [key, value] of Object.entries(res)) {
              res[key] = { ...value };
              const sortedArray = Utility.sortLoyaltyItems(
                unFilteredData,
                "reqPointsToRedeem",
                "itemPrice",
                "desc",
              );
              state.nxgLoyaltyMenuDataArray = sortedArray;
              res[key].data = sortedArray.reduce(function (result, key) {
                result[key] = value.data[key];
                return result;
              }, {});
            }
          } else if (_.type == "LOW_TO_HIGH") {
            for (const [key, value] of Object.entries(res)) {
              res[key] = { ...value };
              const sortedArray = Utility.sortLoyaltyItems(
                unFilteredData,
                "reqPointsToRedeem",
                "itemPrice",
                "asc",
              );
              state.nxgLoyaltyMenuDataArray = sortedArray;
              res[key].data = sortedArray.reduce(function (result, key) {
                result[key] = value.data[key];
                return result;
              }, {});
            }
          }
        }
      });

      if (resetSort) {
        const sortedArray = Utility.sortLoyaltyItems(
          unFilteredData,
          "reqPointsToRedeem",
          "itemPrice",
          "asc",
        );
        state.nxgLoyaltyMenuDataArray = sortedArray || [];
      }
      state.nxgLoyaltyMenuData = res;
    },
    updateLoyaltyBalanceDetailsFromUserStore(state, payload) {
      const { balance = {}, programConfig = {} } =
        payload?.loyaltyProgram || {};

      const menuTypeFromStore = Utility.loyaltyProductMenuType();
      const {
        programVersion = false,
        redeemCap = null,
        maxPoints = null,
        maxItems = null,
        menuType = "",
        redeemPointsSlab = [],
      } = programConfig || {};
      const { overall = {} } = balance;
      state.loyaltyMenuType = menuType || menuTypeFromStore;
      state.redeemPointsSlab = redeemPointsSlab;
      if (!programVersion || programVersion == "v1") {
        state.maxLoyaltyPointsToBeRedeemed = overall?.points;
      } else {
        if (redeemCap) {
          switch (redeemCap?.toLowerCase()?.trim()) {
            case "max_points":
              state.maxLoyaltyPointsToBeRedeemed =
                overall?.points > maxPoints ? maxPoints : overall?.points;
              break;
            case "max_items":
              state.maxPizzaToBeRedeemed = maxItems || 0;
              state.maxLoyaltyPointsToBeRedeemed = overall?.points || 0;
              break;
            default:
              state.maxLoyaltyPointsToBeRedeemed = overall?.points || 0;
              break;
          }
        } else {
          state.maxLoyaltyPointsToBeRedeemed = overall?.points || 0;
        }
      }
    },
    updateLoyaltyMenuApiLoaded(state, payload) {
      state.loyaltyMenuApiLoaded = payload;
    },
    updateLoyaltyProducts(state, payload) {
      state.loyaltyProductsData = payload;
    },
    updateAppDataReceived(state, payload) {
      state.appDataReceived = payload;
    },
    updateLoyaltyProductsDataForceRefresh(state, payload) {
      state.loyaltyProductsDataForceRefresh = payload;
    },
    updateMinimumPointsShownToUser(state, payload) {
      state.minimumPointsShownToUser = payload;
    },
  },
  actions: {
    async bridgingApi({ commit }, payload) {
      try {
        if (!payload.api || !payload.token) {
          throw new Error("Token is missing");
        }

        ApiCalls.BRIDGING_API({
          headers: headers(),
          payload: payload,
        })
          .then(function (response) {
            if (response?.data) {
              const { accessToken, refreshToken, userId, status, redirectUrl } =
                response.data;
              if (
                status &&
                accessToken &&
                refreshToken &&
                userId &&
                redirectUrl
              ) {
                commit("updateBridgeData", response.data);
              }
            }
          })
          .catch(function (error) {
            console.error("Bridging API Error: ", error);
            commit("updateBridgeError", error.message);
            commit(
              keyMapsMutation.UPDATE_ALERT_MODAL_MSG,
              {
                msg: "Oops! Something went wrong. Please try again after sometime.",
                cta: "Dismiss",
              },
              { root: true },
            );
            commit(keyMapsMutation.UPDATE_SHOW_ALERT_MODAL, true, {
              root: true,
            });
            commit("updateBridgeData", {});
          })
          .finally(() => {
            commit("updateIsBridgeApiLoaded", true);
          });
      } catch (error) {
        commit(
          keyMapsMutation.UPDATE_ALERT_MODAL_MSG,
          {
            msg: "Oops! Something went wrong. Please try again after sometime.",
            cta: "Dismiss",
          },
          { root: true },
        );
        commit(keyMapsMutation.UPDATE_SHOW_ALERT_MODAL, true, {
          root: true,
        });
        // commit("updateIsBridgeApiLoaded", true);
      }
    },
    getCheesyFAQData({ commit, rootGetters }, payload) {
      ApiCalls.CHEESY_FAQ_DATA_API({
        headers: {
          ...Headers(),
        },
        payload,
      })
        .then(function (response) {
          if (response?.data) {
            commit("updateCheesyFaqData", {
              data: response.data?.data,
              version: payload.programVersion,
            });
          } else {
            commit("updateCheesyFaqData", null);
          }
        })
        .catch(function (error) {
          commit("updateCheesyFaqData", null);
        })
        .finally(function () {});
    },
    getCheesyPOTPInfo({ commit, rootGetters }, payload) {
      ApiCalls.CHEESY_POTP_INFO_API({
        headers: {
          ...Headers(),
        },
        payload,
      })
        .then(function (response) {
          if (response?.data) {
            commit("updateCheesyPOTPInfoData", {
              data: response.data?.data,
              version: payload.programVersion,
            });
          } else {
            commit("updateCheesyPOTPInfoData", null);
          }
        })
        .catch(function (error) {
          commit("updateCheesyPOTPInfoData", null);
        })
        .finally(function () {});
    },
    loyaltyStatementApi({ commit, rootGetters }, payload) {
      ApiCalls.LOYALTY_STATEMENT_API({
        headers: Headers(),
        payload,
      })
        .then(function (response) {
          commit("updateLoyaltyStatement", response.data);
          if (response.data.data.length) {
            commit("updateShowHistoryCta", true);
          }
        })
        .catch(function (error) {})
        .finally(() => {
          commit("updateLoyaltyStatementApiSettled", true);
        });
    },
    walletCashbackApi({ commit, rootGetters }, payload) {
      ApiCalls.WALLET_CASHBACK_API({
        headers: Headers(),
        payload,
      })
        .then(function (response) {
          commit("updateWalletData", response.data);
        })
        .catch(function (error) {})
        .finally(() => {
          commit("updateWalletCashbackApiSettled", true);
        });
    },
    optOutLoyaltyApi({ commit, rootGetters }, payload) {
      ApiCalls.OPT_OUT_LOYALTY_API({
        headers: Headers(),
        payload,
      })
        .then(function (response) {
          if (response?.data) {
            commit(keyMapsMutation.UPDATE_LOYALTY, response.data, {
              root: true,
            });
            commit("updateOptOutLoyaltyEnabled", false);
            commit(keyMapsMutation.REMOVE_LOYALTY_CART_ITEMS, null, {
              root: true,
            });
            Utility.redirectionMultiAsset({
              action: "quitLoyalty",
              href: "",
              title: "Opt Out Loyalty",
              obj: response?.data,
            });
          } else {
            throw new Error("failed");
          }
        })
        .catch(function (error) {
          commit("updateOptOutLoyaltyEnabled", false);
          commit(keyMapsMutation.UPDATE_SHOW_ALERT_MODAL, true, {
            root: true,
          });
        });
    },
    loyaltyMenuDataApi({ commit, state }, payload) {
      let api = payload?.api;
      const menuTypeFromStore = Utility.loyaltyProductMenuType();
      const menuTypeIs = state.loyaltyMenuType || menuTypeFromStore;
      api = api.replace(":menuType", menuTypeIs);

      ApiCalls.LOYALTY_MENU_DATA_API({
        headers: Headers(),
        payload: {
          api: api,
        },
      })
        .then(function (response) {
          if (response?.data?.data) {
            commit("updateLoyaltyProducts", response.data?.data);
            if (payload.syncMenu) {
              commit("updateLoyaltyProductsDataForceRefresh", true);
            }
          } else if (response?.response?.status === 404) {
            commit("updateLoyaltyProducts", {});
          } else {
            throw new Error("no data");
          }
        })
        .catch(function (error) {
          console.error("LOYALTY MENU API Error: ", error);
          commit(keyMapsMutation.UPDATE_SHOW_ALERT_MODAL, true, {
            root: true,
          });
          commit("updateLoyaltyProducts", null);
        })
        .finally(function () {
          commit("updateLoyaltyMenuApiLoaded", true);
        });
    },
    actionToSyncLoyaltyBalanceStore({ state, commit }, payload = {}) {
      commit("updateLoyaltyBalanceDetailsFromUserStore", payload);
    },
  },
};
